// import qs from 'query-string';
// import { FEATURE_SWITCH } from '../constants/feature-switch';
// eslint-disable-next-line no-unused-vars
const withInternalPath = (url: string, internalPath?: string) => {
    return url;
    // if (!internalPath || !FEATURE_SWITCH.UTM_INTERNALPATH) {
    //     return url;
    // }

    // return qs.stringifyUrl(
    //     {
    //         query: { utm_internalpath: internalPath },
    //         url
    //     },
    //     {
    //         encode: false
    //     }
    // );
};

export default withInternalPath;
